import React from 'react';
import { Mail, MapPin, Phone } from 'lucide-react';

const Contact = () => {
  return (
    <div className="page-content page-top">
      <div className="container-medium">
        <div className="page-header">
          <h1 className="page-title">Get In Touch</h1>
          <p className="page-subtitle">
            Have questions? We'd love to hear from you. Send us a message and we'll respond as soon as possible.
          </p>
        </div>

        <div className="contact-grid">
          <div className="contact-info-section">
            <div className="content-card">
              <h2 className="section-title">Contact Information</h2>
              
              <div className="contact-item">
                <div className="contact-icon">
                  <Mail size={24} />
                </div>
                <div>
                  <div className="contact-label">Email</div>
                  <a href="mailto:service@xndeals.online" className="contact-link">
                    service@xndeals.online
                  </a>
                </div>
              </div>

              <div className="contact-item">
                <div className="contact-icon">
                  <Phone size={24} />
                </div>
                <div>
                  <div className="contact-label">Phone</div>
                  <a href="tel:+17144639515" className="contact-link">
                    +1 (714) 4639515
                  </a>
                </div>
              </div>

{/*              <div className="contact-item">
                <div className="contact-icon">
                  <MapPin size={24} />
                </div>
                <div>
                  <div className="contact-label">Office</div>
                  <div className="contact-text">
                    123 Business Street<br />
                    San Francisco, CA 94102<br />
                    United States
                  </div>
                </div>
              </div>*/}

              <div className="business-hours">
                <div className="contact-label">Business Hours</div>
                <div className="contact-text">
                  Monday - Friday: 9:00 AM - 6:00 PM PST<br />
                  Saturday - Sunday: Closed
                </div>
              </div>
            </div>
          </div>

          <div className="contact-form-section">
            <div className="content-card">
              <h2 className="section-title">Send Us a Message</h2>
              
              <form className="contact-form">
                <div className="form-group">
                  <label>Full Name</label>
                  <input type="text" placeholder="John Doe" />
                </div>

                <div className="form-group">
                  <label>Email Address</label>
                  <input type="email" placeholder="john@example.com" />
                </div>

                <div className="form-group">
                  <label>Subject</label>
                  <input type="text" placeholder="How can we help?" />
                </div>

                <div className="form-group">
                  <label>Message</label>
                  <textarea rows="5" placeholder="Tell us more about your inquiry..."></textarea>
                </div>

                <button type="submit" className="btn btn-primary btn-full">
                  Send Message
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
